import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaterMonitoringComponent } from './water-monitoring.component';
import { RouterModule } from '@angular/router';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { WaterQualityDataComponent } from './water-quality-data/water-quality-data.component';
import { MonitoringWaterQualityComponent } from './monitoring-water-quality/monitoring-water-quality.component';
import { HowWeMonitorComponent } from './how-we-monitor/how-we-monitor.component';
import { HowWeReportComponent } from './how-we-report/how-we-report.component';
import { BeachwatchDataFeedsComponent } from './beachwatch-data-feeds/beachwatch-data-feeds.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ListService } from '../services/list.service';
import { SitesService } from '../services/sites.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DownloadDataService } from '../services/download-data/download-data.service';
import { WaterMonitoringLandingComponent } from './water-monitoring-landing/water-monitoring-landing.component';
import { RegionCouncilBeachSitesSelectionComponent } from './region-council-beach-sites-selection/region-council-beach-sites-selection.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DatatableComponent } from './datatable/datatable.component';
import { RegionCouncilTreeListComponent } from './region-council-beach-sites-selection/region-council-tree-list/region-council-tree-list.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { AppMonitoringService } from '../services/logging.service';

@NgModule({
	declarations: [
		WaterMonitoringComponent, 
		WaterQualityDataComponent, 
		MonitoringWaterQualityComponent, 
		HowWeMonitorComponent, 
		HowWeReportComponent, 
		BeachwatchDataFeedsComponent, 
		WaterMonitoringLandingComponent,
		RegionCouncilBeachSitesSelectionComponent,
  		DatatableComponent,
		RegionCouncilTreeListComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		SharedCompsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatFormFieldModule,
		MatTableModule,
		MatPaginatorModule,
		MatTreeModule,
		MatIconModule	
	],
	exports : [
		WaterMonitoringComponent, 
		WaterQualityDataComponent, 
		MonitoringWaterQualityComponent, 
		HowWeMonitorComponent, 
		HowWeReportComponent, 
		BeachwatchDataFeedsComponent,
		RegionCouncilBeachSitesSelectionComponent,		
		RegionCouncilTreeListComponent
	],
	providers : [ListService, SitesService, DownloadDataService,AppMonitoringService]
})
export class WaterMonitoringModule { }
